import { useGetTeamsId } from "@/shared/api/generated-kubb/hooks/useGetTeamsId";
import { QUERY_SPECIFIC_CONFIG } from "@/shared/config";

export function useTeam(id: string) {
  const query = useGetTeamsId(id, {
    query: {
      enabled: Boolean(id),
      staleTime: QUERY_SPECIFIC_CONFIG.TOURNAMENT_DETAIL.staleTime,
      gcTime: QUERY_SPECIFIC_CONFIG.TOURNAMENT_DETAIL.gcTime,
    },
  });

  return {
    ...query,
    data: query.data?.data ?? null,
  };
}
